import Collapse from './Collapse';

export default Collapse;



// WEBPACK FOOTER //
// ./components/collapse/index.tsx